<template>
  <b-modal
    id="confirmModal"
    v-model="confirmModal.show"
    :title="confirmModal.title"
    :ok-title="confirmModal.yesText"
    :ok-variant="confirmModal.okVariant"
    :cancel-title="confirmModal.noText"
    :cancel-variant="confirmModal.cancelVariant"
    @ok="handleOk"
  >
    <p>{{ confirmModal.text }}</p>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'ConfirmModal',
  computed: {
    ...mapState({
      confirmModal: state => state.sunModel.confirmModal,
    }),
  },
  methods: {
    handleOk() {
      if (this.confirmModal.callback) {
        this.confirmModal.callback();
      }
    },
  },
};
</script>

<style lang="scss">
  #factModal {
    /deep/ .lobi-spinner {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: white;
      z-index: 1;
    }
  }
</style>